// UserRateItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import FormDatePicker from '../../../common/form/form_datepicker/form_datepicker.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import InputPrice from '../../../common/form/input_price/input_price.jsx'

class UserRateItem extends Component {
  constructor (props) {
    super(props)

    this._references = {
      refUserDatePicker: React.createRef(),
      inputCostRate: React.createRef()
    }
  }

  static get propTypes () {
    return {
      item: PropTypes.object,
      onChange: PropTypes.func,
      onDelete: PropTypes.func,
      showDelete: PropTypes.bool,
      prefixCurrency: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      item: {},
      onChange: null,
      onDelete: null,
      showDelete: false,
      prefixCurrency: ''
    }
  }

  render () {
    const item = this.props.item

    return (
      <div className='user-rateitem'>
        <div className='colleft'>
          <FormDatePicker
            placeholder='setting.userForm.datePlaceholder'
            ref={this._references.refUserDatePicker}
            value={item.date ? new Date(item.date) : null}
            onChange={this._onChangeInput.bind(this, 'date')}
            onFocus={this._onFocus.bind(this, 'date')}
          />
        </div>
        <div className='colright'>
          <InputPrice
            type='text'
            name='rate'
            showDecimal
            ref={this._references.inputCostRate}
            value={item.rate ? item.rate : 0}
            prefixCurrency={this.props.prefixCurrency}
            size={10}
            maxLength={128}
            validations={['required', 'price']}
            onChange={this._onChangeInput.bind(this, 'rate')}
          />

          <InputPrice
            type='text'
            name='costRate'
            showDecimal
            value={item.costRate ? item.costRate : 0}
            className='alt'
            size={10}
            maxLength={128}
            validations={['price']}
            prefixCurrency={this.props.prefixCurrency}
            onChange={this._onChangeInput.bind(this, 'costRate')}
          />
        </div>
        {this.props.showDelete && (
          <IconButton
            icon='common-item-delete'
            canHover={false}
            className='budget'
            onClick={this._onDelete.bind(this)}
          />
        )}
      </div>
    )
  }

  validate () {
    if (this._references.inputCostRate.current) {
      if (this._references.inputCostRate.current.validate()) {
        this._references.inputCostRate.current.clearError()
        return true
      }

      return false
    }

    return true
  }

  /* Event handler */
  _onChangeInput (name, value) {
    this.props.item[name] = value

    if (this.props.onChange) {
      this.props.onChange(this.props.item)
    }
  }

  _onFocus (_name, _value) {
    if (this._references.refUserDatePicker.current) {
      this._references.refUserDatePicker.current.showDatePicker()
    }
  }

  _onDelete () {
    if (this.props.onDelete) {
      this.props.onDelete()
    }
  }
}

export default UserRateItem
